/**
 * Executes a search on a string using a regular expression pattern, and returns an array containing all results of that search.
 * // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec#finding_successive_matches
 *
 * @param string — The String object or string literal on which to perform the search.
 */
export const regexExecAll = (string: string, pattern: string | RegExp, flags = 'g'): RegExpExecArray[] => {
    if (!string) {
        return []
    }

    const regex = pattern instanceof RegExp ? pattern : new RegExp(pattern, flags)
    const allMatches: RegExpExecArray[] = []
    let whileMatch: RegExpExecArray | null = null
    // eslint-disable-next-line no-cond-assign
    while ((whileMatch = regex.exec(string))) {
        allMatches.push(whileMatch)
    }

    return allMatches
}
